export enum FinishReasons {
  Unanswered = 'UNANSWERED',
  Declined = 'DECLINED',
  Finished = 'FINISHED',
}

export enum CallType {
  P2P = 'P2P',
  Group = 'GROUP',
  Conference = 'CONFERENCE',
  Stream = 'STREAM',
  Room = 'ROOM',
}

export enum CallParticipantRole {
  Superuser = 'SUPERUSER',
  Member = 'MEMBER',
  Guest = 'GUEST',
}

export interface ICallinitialParticipant {
  userId: string;
  role?: CallParticipantRole;
}

export interface ICreateRoomParams {
  roomName: string;
  allowGuests: boolean;
  waitingRoomEnabled: boolean;
  webinar: boolean;
  initialParticipants: ICallinitialParticipant[];
}

export const AUTO_DECLINE_REASON = {
  call: 'Has active call',
  stream: 'Has active stream',
  waitingRoom: 'Has waiting room request',
};
